import { axiosAmApiInstance as amApi } from 'utils/axios';

type IntercomTokenResponse = {
  token: string;
};

export const fetchIntercomToken = async (): Promise<string> => {
  const response = await amApi.get(`/authorization/intercom-token`);

  return (response.data as IntercomTokenResponse).token;
};
